import React from "react";
import "./Loading.css";

export default function Loading() {
  return (
    <div className="spinner">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js